import React from "react";
import { useTheme } from "styled-components";
import { useAuth } from "../../hooks/auth";
import { Text } from "@hangar/web-components/core/Text";
import { SecurityPadlock } from "@hangar/react-icons/core/latam/Security/SecurityPadlock";
import { Breadcrumb } from "../../components/Breadcrumb";
import {
  Container
} from "./DemoUser.styles";

export const DemoUser: React.FC = () => {
  const { userProfile } = useAuth();
  const {
    tokens: { color },
  } = useTheme();

  const userName = userProfile?.givenName || userProfile?.name || userProfile?.email || "Usuario";

  return (
    <>
      {/* Breadcrumb Header */}
      <Breadcrumb
        title="Panel de usuario"
        description="Centro de control para usuarios del sistema"
        items={[
          { label: "User Panel" }
        ]}
      />
      
      <Container>
        <Text variant="body-md" className="subtitle">
          Bienvenido, {userName} - Acceso completo al sistema - Solo accesible para rol demo.admin
        </Text>
      </Container>
    </>
  );
};